export const version = "1793800463";
export const env = "production";
export const flavor = "Zii";

export const stripeKeys = {
  AU: "pk_live_51GvGtIKX4sqebhqJXyfOoQPkfkUooXybkD1Wpo8eAFD3bCIReO9uCcSjIUuvBiKCJlyzVBNt0Pi7VWHzq0QQuGvt00PiHChO98",
  SG: "pk_live_51P6RMEDSc4OfWK4d5C5LDwvJvMRxKpgh4LtQkqkeVUytaPwA85snWIGiD359L83Wt4BfCkfwNJ7OKke5zBu4cjt900AqZTaAyu",
  JP: "pk_live_51T7xoABB95ppVUF3SDLEEu4izgcf5zdvFubtBhjXKmYXT7EFCIvGErLRU3psPkKkLdZuan4kLP6IRcdFIqjwM7YN00bXqm1h0Y",
  MY: "pk_live_51TOsAdPgNQDu6T8pvI4z2CLT2E8J1uAdasAz9H4cbR45smRxwhkZqP3JmlQ1oHLQ6kkE5O1eVSozhuXw8ZNXhxVF00Y0z10bFH",
};

export const stripeSubKeyIntentions = {
  AU: 1,
  SG: 3,
  JP: 5,
  MY: 6,
};

export const stripeKey =
  "pk_live_51GvGtIKX4sqebhqJXyfOoQPkfkUooXybkD1Wpo8eAFD3bCIReO9uCcSjIUuvBiKCJlyzVBNt0Pi7VWHzq0QQuGvt00PiHChO98";
export const defaultStripeRegion = "AU";
export const stripeClientId = "ca_JIDdhTMwhkzf216fd73pP4cUQEablwmO";
export const stripeSGClientId = "ca_Mt4QltcPfqEr5fBei9UHwMLydYICvRJU";
export const stripeJPClientId = "ca_UCoalqQg5IkweeqjtXHyDQRaAtHHVhiD";
export const ubereatsClientId = "M9DUQSL9V7f3TR6RtR9cx21lec7ydzz8"; // incorrect, just for temporary use.

export const cloudImageBaseUrl = "https://res.ziicloud.com/";
export const tyroClientId = "VV69PLaj7Q8TFIlTcg3HtvLpTK0aDwrR";

export const xeroConnectUrl = 'https://login.xero.com/identity/connect/authorize?response_type=code';
export const xeroConnectRedirectUrl = 'https://portal.ziicloud.com/integration/xero-redirect'

export const innerSuperAdmins = [-2, -11, -33, -37, -38];
